import axios from 'axios';

const RETRYABLE_STATUSES = new Set([408, 429, 500, 502, 503, 504]);
const MAX_ATTEMPTS = 3;
const INITIAL_BACKOFF = 800;
const TIMEOUT = 120000;

function isRetryable(error) {
  if (error.code === 'ECONNABORTED') return true;
  if (!error.response) return true;
  return RETRYABLE_STATUSES.has(error.response.status);
}

export async function uploadImage(api, file, onProgress) {
  const fd = new FormData();
  fd.append('file', file);

  for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
    try {
      const res = await axios.post(`${api}/upload-image`, fd, {
        timeout: TIMEOUT,
        onUploadProgress: onProgress
          ? (e) => onProgress(e.total ? Math.round((e.loaded / e.total) * 100) : 0)
          : undefined,
      });
      return { ok: true, url: res.data.url, data: res.data };
    } catch (error) {
      const isLast = attempt === MAX_ATTEMPTS;
      if (isLast || !isRetryable(error)) {
        const message =
          error.response?.data?.detail ||
          error.response?.statusText ||
          error.message ||
          'Upload failed';
        return { ok: false, error: message };
      }
      await new Promise((r) => setTimeout(r, INITIAL_BACKOFF * 2 ** (attempt - 1)));
    }
  }
}

export async function uploadImages(api, files, onBatchProgress) {
  const uploaded = [];
  const failed = [];
  const total = files.length;

  for (let i = 0; i < files.length; i++) {
    if (onBatchProgress) onBatchProgress({ current: i + 1, total, percent: 0 });
    const result = await uploadImage(api, files[i], (percent) => {
      if (onBatchProgress) onBatchProgress({ current: i + 1, total, percent });
    });
    if (result.ok) {
      uploaded.push({ file: files[i], url: result.url });
    } else {
      failed.push({ name: files[i].name, error: result.error });
    }
  }

  return { uploaded, failed };
}

export function describeFailures(failed) {
  return failed.map((f) => `• ${f.name} — ${f.error}`).join('\n');
}
